export default "__VITE_PUBLIC_ASSET__ba162a6f__"